// Shared math utilities for AR heading and angle calculations.

import * as THREE from 'three';

/**
 * Returns the unsigned horizontal angle in degrees between two world-space
 * vectors projected onto the XZ plane (Y ignored).
 * Result is in the range [0, 180].
 */
export function horizontalAngleDeg(a: THREE.Vector3, b: THREE.Vector3): number {
  const ah = new THREE.Vector3(a.x, 0, a.z);
  const bh = new THREE.Vector3(b.x, 0, b.z);
  if (ah.lengthSq() === 0 || bh.lengthSq() === 0) return 0;
  ah.normalize();
  bh.normalize();
  const dot = Math.max(-1, Math.min(1, ah.dot(bh)));
  return THREE.MathUtils.radToDeg(Math.acos(dot));
}
